import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute'; // Import the ProtectedRoute component
import Navbar from './pages/Navbar';
import Landing from './pages/Landing';
import Home from './pages/Home';
import Signup from './pages/Signup';
import Signin from './pages/Signin';
import NotFound from './pages/NotFound';
import TrackNewProduct from './pages/TrackNewProduct';
import AddDetails from './pages/AddDetails';
import VerifyProduct from './pages/VerifyProduct';
import TrackingList from './pages/TrackingList';
import About from './pages/About';
import Contact from './pages/Contact';
import Edit from './components/Edit';
import Delete from './components/Delete';
// import ProductDetails from './components/ProductDetails';
import ProductDetails from './pages/ProductDetails';
import Account from './pages/Account';
import EditAccountDetails from './pages/EditAccountDetails';
import VerifyOTP from './components/VerifyOTP';
import NewPassword from './pages/NewPassword';
import Footer from './pages/Footer';


const AppLayout = () => (
  <div className="App">
    <Navbar />
    {/* <hr /> */}
    <Outlet /> {/* This will render the current route's component */}
    <Footer />
  </div>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { path: "/", element: <Landing /> }, // Landing Page
      {
        path: "/home",
        element: (
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        )
      }, // Home page wrapped inside ProtectedRoute
      { path: "/signup", element: <Signup /> }, // Sign up page
      { path: "/signin", element: <Signin /> }, // Sign in page
      { path: "/about", element: <About /> },
      { path: "/contact", element: <Contact /> },
      { path: "/account", element: <Account /> },
      { path: "/editAccountDetails", element: <EditAccountDetails /> },
      { path: "/changePassword", element: <VerifyOTP /> },
      { path: "/newPassword", element: <NewPassword /> },
      { path: "/product/:id", element: <ProductDetails /> },
      { path: "/addProduct", element: <TrackNewProduct /> },
      { path: "/addProduct/addDetails", element: <AddDetails /> },
      { path: "/addProduct/verifyProduct", element: <VerifyProduct /> },
      { path: "/addProduct/productVerified/continue", element: <AddDetails /> },
      { path: "/trackinglist", element: <TrackingList /> },
      { path: "*", element: <NotFound /> },   // 404 page
    ],
  },
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;
